export default {
    name: 'QBadge',
    props: {
        color: {
            type: String,
            default: ''
        },
        // circle or square
        shape: {
            type: String,
            default: 'circle'
        }
    },
    computed: {
        bgColor() {
            return this.color ? `bg-${this.color}` : '';
        },
        hasIcon() {
            return !!this.$slots.icon;
        }
    }
};
